// Add job to favorites. **************************************************************************
// pathname: /v1/job/{slug}/favorite
// method:   POST
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description SWR mutation: POST add job to favorites. Response status ok: 200.
 * @param jobSlug - string. The job slug.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param successToastText - string. The text to show in the success toast.
 */
export const useSwrJobAddToFavorites = (jobSlug: string, locale: string = 'ro', successCallback?: () => void, successToastText?: string) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/job/${jobSlug}/favorite`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
